import { render, staticRenderFns } from "./UpdateRuleGroup.vue?vue&type=template&id=30d55f2e"
import script from "./UpdateRuleGroup.vue?vue&type=script&lang=js"
export * from "./UpdateRuleGroup.vue?vue&type=script&lang=js"
import style0 from "./UpdateRuleGroup.vue?vue&type=style&index=0&id=30d55f2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports